// components/Contact.jsx
import React from 'react';
import '../assets/css/Contact.css';

const Contact = () => {
  return (
    <section id="contact" className="contact">
      <h2>Contact Us</h2>
      <p>Reach out to learn how our virtual assistants can help your business grow</p>
      
      <div className="contact-container">
        <div className="contact-info">
          <h3>Get In Touch</h3>
          <div className="contact-item">
            <h4>📍 Address</h4>
            <p>Bulacan, Philippines</p>
          </div>
          <div className="contact-item">
            <h4>📧 Email</h4>
            <p>info@bpdocorp.com</p>
          </div>
          <div className="contact-item">
            <h4>🌐 Website</h4>
            <p>www.bpdocorp.com</p>
          </div>
        </div>
        
        {/* Contact information only - form removed */}
        <div className="contact-cta">
          <h3>Ready to Get Started?</h3>
          <p>Schedule a consultation with us to discuss how our virtual assistants can help your business grow.</p>
          <a href="#why-us" className="btn-primary">
            Schedule a Consultation
          </a>
        </div>
      </div>
    </section>
  );
};

export default Contact;